module.exports = __webpack_public_path__ + "img/House searching-amico.36ce6136.svg";